import SocialWrapper from './SocialWrapper'
export default SocialWrapper
